/* eslint-disable no-param-reassign, prefer-destructuring, func-names, sonarjs/no-duplicate-string
 */
// Detect request animation frame
const scroll = window.requestAnimationFrame
             // IE Fallback
             || function (callback) { window.setTimeout(callback, 1000 / 60); };
const elementsToShow = document.querySelectorAll('.show-on-scroll');
const elementTopWrapper = document.querySelectorAll('.top-wrapper');

function isElementInViewport(el) {
  // special bonus for those using jQuery
  if (typeof jQuery === 'function' && el instanceof jQuery) {
    el = el[0];
  }
  const rect = el.getBoundingClientRect();
  return (
    (rect.top <= 0
            && rect.bottom >= 0)
        || (rect.bottom >= (window.innerHeight || document.documentElement.clientHeight)
            && rect.top <= (window.innerHeight || document.documentElement.clientHeight))
        || (rect.top >= 0
            && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))
  );
}

function loop() {
  elementsToShow.forEach((element) => {
    if (isElementInViewport(element)) {
      element.classList.add('is-visible');
    } else {
      element.classList.remove('is-visible');
    }
  });

  elementTopWrapper.forEach((element) => {
    if (isElementInViewport(element)) {
      $('.main-left').css('position', 'relative');
      $('.main-left').css('top', 'unset');
    } else {
      $('.main-left').css('position', 'fixed');
      $('.main-left').css('top', 0);
    }
  });

  scroll(loop);
}
// Call the loop for the first time
loop();

// Helper function from: http://stackoverflow.com/a/7557433/274826
/* eslint-enable */
